<script setup lang="ts">
import { computed } from "vue";
import { useConditionStore } from "../condition/conditions.store";

import ConditionLabel from "../condition/ConditionLabel.vue";

import type { RequirementItem } from "./RequirementItem";

const props = defineProps<{
  requirement: RequirementItem;
  index: number;
}>();

const conditionStore = useConditionStore();

const conditions = computed(() => {
  return conditionStore.byRequirement[props.requirement.id] || [];
});
</script>

<template>
  <div>
    <div class="requirement-title__heading">
      {{ $t("objectNames.requirement") }} {{ index + 1 }}
    </div>
    <span v-if="requirement.title">{{ requirement.title }}</span>
    <span v-else>
      <i v-if="conditions.length == 0">
        {{ $t("labels.noConditions") }}
      </i>
      <span v-else-if="conditions.length == 1">
        <condition-label :condition-id="conditions[0].id" />
      </span>
      <span v-else-if="conditions.length > 1">
        {{ conditions.length }}
        {{ $t("objectNames.condition", conditions.length) }}
      </span>
    </span>
  </div>
</template>

<style>
.requirement-title__heading {
  font-size: 12px;
  font-weight: bold;
  color: var(--color-text-medium);
  margin-bottom: 0.25rem;
}
</style>
